import React from "react";
import Note from "./Note";
import Review from "./Review";
import Photos from "./Photos";
import Cancel from "./Cancel";
import Dispute from "./Dispute";
import PT from "prop-types";
import Modal, { Header } from "_c/Modals";

const TaskActions = ({ task, active, t, ...props }) => {
  const isOpen = Boolean(active);
  return (
    <Modal isOpen={isOpen} onClose={props.onClose}>
      <Header onClick={props.onClose}>{t("common:close")}</Header>
      {active === "note" && (
        <Note
          isTaskConsumer={props.isTaskConsumer}
          t={t}
          removeNote={props.removeNote}
          createNote={props.createNote}
          task={task}
        />
      )}
      {active === "review" && (
        <Review onClose={props.onClose} t={t} task={task} />
      )}
      {active === "upload" && (
        <Photos
          isTaskMaster={props.isTaskMaster}
          isTaskConsumer={props.isTaskConsumer}
          t={t}
          task={task}
        />
      )}
      {active === "cancel" && (
        <Cancel
          task={task}
          onCancel={props.onCancel}
          onClose={props.onClose}
          t={t}
        />
      )}
      {active === "dispute" && (
        <Dispute onClose={props.onClose} t={t} task={task} />
      )}
    </Modal>
  );
};
TaskActions.propTypes = {
  active: PT.string,
  task: PT.object,
  isTaskMaster: PT.bool,
  isTaskConsumer: PT.bool,
  currency: PT.string,
  locale: PT.string,

  t: PT.func.isRequired,
  onClose: PT.func.isRequired,
  createNote: PT.func.isRequired,
};
export default TaskActions;
